import React, { Component } from 'react';
import ParseObjectTypeName from '../helpers/parseObjectTypeName';
import './ObjectSearchItem.css';

class ObjectSearchItem extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    // for better performance, only update component if it's been selected or deselected
    return (
      nextProps.selectedObject.id === this.props.id ||
      this.props.selectedObject.id === this.props.id
    );
  }

  componentDidMount() {
    const objectIsSelected = this.props.selectedObject.id === this.props.id;
    // only scroll the component into view if it was selected from the map
    if (objectIsSelected && this.props.selectedObject.triggeredFromMap) {
      this.props.scrollObjectIntoView(this, 'instant');
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const objectIsSelected = this.props.selectedObject.id === this.props.id;
    // only scroll the component into view if it was selected from the map
    if (objectIsSelected && this.props.selectedObject.triggeredFromMap) {
      this.props.scrollObjectIntoView(this);
    }
  }

  render() {
    const objectIsSelected = this.props.selectedObject.id === this.props.id;
    let bg =
      process.env.NODE_ENV === 'development'
        ? 'http://dios.local.cloudnine.se' + this.props.image
        : this.props.image;
    let componentName = 'objectsearchlisting__item';

    return (
      <li
        className={`${componentName} ${
          this.props.classModifier
            ? `${componentName}${this.props.classModifier}`
            : ''
        } ${objectIsSelected ? componentName + '--is-selected' : ''}`}
      >
        <a
          href={this.props.link}
          onMouseEnter={() => {
            this.props.selectObject(this.props.id, false);
          }}
        >
          <div
            className="objectsearchlisting__image"
            style={{ backgroundImage: "url('" + bg + "?width=320')" }}
          >
            <img
              src={this.props.image + '?width=320'}
              alt="bild på fastigheten"
            />
          </div>
          <div className="objectsearchlisting__type">
            {ParseObjectTypeName(this.props.type)}
          </div>

          <div className="objectsearchlisting__title">{this.props.title}</div>

          <div className="objectsearchlisting__button">
            Läs mer
            <svg
              className="svg-icon"
              width="26"
              height="26"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 26 26"
            >
              <g fill="#03536C" fillRule="nonzero">
                <path d="M13 0C5.82 0 0 5.82 0 13s5.82 13 13 13 13-5.82 13-13S20.18 0 13 0zm0 24.267C6.778 24.267 1.733 19.222 1.733 13 1.733 6.778 6.778 1.733 13 1.733c6.222 0 11.267 5.045 11.267 11.267A11.267 11.267 0 0113 24.267z" />
                <path d="M9.351 7.549L14.811 13l-5.46 5.451 1.231 1.231L17.255 13l-6.673-6.682z" />
              </g>
            </svg>
          </div>
        </a>
      </li>
    );
  }
}
export default ObjectSearchItem;



// WEBPACK FOOTER //
// ./src/js/components/ObjectSearchItem.js